import {
    GET_EXECUTION_LOG_SUCCESS,
    RUN_GLOBAL_API_LOG_DATA,
    FETCH_START,
    FETCH_END,
    GET_CUSTOM_TABLES,
    GET_CUSTOM_TABLE_BY_ID_SUCCESS,
    ADD_CUSTOM_TABLE_SUCCESS,
    EDIT_CUSTOM_TABLE_SUCCESS,
    GET_EXTEND_TABLE_FIELDS_SUCCESS,
    LAYOUT_RENDER_SUCCESS,
    ADD_FILTER_CONFIGURATION_SUCCESS,
    GET_FILTER_CONFIGURATIONS,
    GET_FILTER_CONFIGURATIONS_BY_PAGE,
    GET_FILTER_CONFIGURATION_BY_ID_SUCCESS,
    DELETE_FILTER_CONFIGURATION_SUCCESS,
    DELETE_FILTER_CONFIGURATION_FAIL,
    GET_EXTERNAL_DATA_MAPPING_BY_ID_SUCCESS,
} from '../../actions/General/ActionTypes';

const initialState = {
    loading: false,
    executionLogData: [],
    globalApiLogData: null,
    customTablesAllData: [],
    customTableByIdData: null,
    extendTableFieldsData: null,
    layoutRenderData: null,
    filterConfigurationsAllData: [],
    filterConfigurationsByPage: [],
    filterConfigurationByIdData: null,
    externalDataMappingById: null,
};

const GeneralReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EXECUTION_LOG_SUCCESS:
            return {
                ...state,
                executionLogData: action.data,
                loading: false,
            };
        case RUN_GLOBAL_API_LOG_DATA:
            return {
                ...state,
                globalApiLogData: action.data,
            };
        case FETCH_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };
        case GET_CUSTOM_TABLES:
            return {
                ...state,
                customTablesAllData: action.data,
            };
        case GET_CUSTOM_TABLE_BY_ID_SUCCESS:
            return {
                ...state,
                customTableByIdData: action.data,
            };
        case ADD_CUSTOM_TABLE_SUCCESS:
            return {
                ...state,
                customTablesAllData: [...(state.customTablesAllData || []), action.data],
            };
        case EDIT_CUSTOM_TABLE_SUCCESS:
            return {
                ...state,
                customTableByIdData: action.data?.response ?? state.customTableByIdData,
            };
        case GET_EXTEND_TABLE_FIELDS_SUCCESS:
            return {
                ...state,
                extendTableFieldsData: action.data,
            };
        case LAYOUT_RENDER_SUCCESS:
            return { ...state, layoutRenderData: action.data, loading: false };
        case ADD_FILTER_CONFIGURATION_SUCCESS:
            return { ...state, filterConfigurationByIdData: action.data };
        case GET_FILTER_CONFIGURATIONS:
            return { ...state, filterConfigurationsAllData: action.data };
        case GET_FILTER_CONFIGURATIONS_BY_PAGE:
            return { ...state, filterConfigurationsByPage: action.data };
        case GET_FILTER_CONFIGURATION_BY_ID_SUCCESS:
            return { ...state, filterConfigurationByIdData: action.data };
        case DELETE_FILTER_CONFIGURATION_SUCCESS:
        case DELETE_FILTER_CONFIGURATION_FAIL:
            return { ...state };
        case GET_EXTERNAL_DATA_MAPPING_BY_ID_SUCCESS:
            return { ...state, externalDataMappingById: action.data };
        default:
            return state;
    }
};

export default GeneralReducer;
